/** Tabs variant `premium` (DEFAULT): line style with a 3px leaf.500 indicator and uppercase label text. Reserved for future use. */
export const Tabs = {
  variants: {
    premium: {
      tablist: { borderBottom: "1px solid", borderColor: "border.default", gap: 2 },
      tab: {
        fontFamily: "body",
        fontSize: "0.75rem",
        fontWeight: 700,
        letterSpacing: "0.08em",
        textTransform: "uppercase",
        color: "text.muted",
        px: 3,
        py: 3,
        borderBottom: "3px solid transparent",
        mb: "-1px",
        _selected: { color: "text.primary", borderColor: "leaf.500" },
        _hover: { color: "text.primary" },
        _focusVisible: { boxShadow: "outline", borderRadius: "sm" },
      },
      tabpanel: { px: 0, py: 5 },
    },
  },
  defaultProps: { variant: "premium" },
};
